/**
 * new-password-client-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Todd L Smith <tsmith@safetyweb.org>
 */

import { ReplyVerifyingMessage } from "../../general/reply-message";
import { MessageTag } from "../../message-tag";

/**
 * A client transmits a {@link NewPasswordClientResponse} to change a user's
 * password. The new password is supplied as the SHA-512 hash of the new
 * client-salted cleartext password.
 */
export class NewPasswordClientResponse extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.CRSP_NEW_PASSWORD;

  /**
   * Construct a new {@link NewPasswordClientResponse}.
   *
   * @param password
   *        The new password, as the SHA-512 hash of the client-salted cleartext
   *        password.
   */
  constructor (public password : string)
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/auth/credentials/new-password-client-response.ts